import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { SheetReconcile } from "./SheetReconcile";
import { TemplateFill } from "./TemplateFill";

export const InsurerSheetsDialog = ({ open, onClose, onSaved }) => {
  const [missing, setMissing] = useState([]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir="rtl" className="max-w-4xl max-h-[92vh] overflow-y-auto" data-testid="insurer-sheets-dialog">
        <DialogHeader><DialogTitle className="font-heading">شيتات شركات التأمين — بالذكاء الاصطناعي</DialogTitle></DialogHeader>
        <Tabs defaultValue="reconcile" dir="rtl">
          <TabsList className="mb-3">
            <TabsTrigger value="reconcile" data-testid="insurer-tab-reconcile">مطابقة كشف الشركة</TabsTrigger>
            <TabsTrigger value="fill" data-testid="insurer-tab-fill">تعبئة نموذج الإضافة</TabsTrigger>
          </TabsList>
          <TabsContent value="reconcile" forceMount className="data-[state=inactive]:hidden">
            <SheetReconcile onResult={(r) => setMissing(r.not_in_sheet.map((x) => x.emp_id))} onSaved={onSaved} />
          </TabsContent>
          <TabsContent value="fill"><TemplateFill missingIds={missing} /></TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
